import '.o{display:flex;}.ssr-plugin'
import '.q{gap:8px;}.ssr-plugin'
import '.a9{height:4px;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { Meter } from './Meter.js'

type StepperProps = {
  steps: number
  currentStep: number
  currentStepProgresss?: number
  style?: Style
}

export const StepperVideo = ({
  steps,
  currentStep,
  currentStepProgresss = 0,
  style,
}: StepperProps) => {
  return (
    <styled.div className="o q a9"
      style={{
        ...style,
      }}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <Meter
          value={
            // for the last slide
            currentStep === steps - 1
              ? 100
              : index === currentStep
                ? currentStepProgresss
                : index < currentStep
                  ? 100
                  : 0
          }
          key={index}
          style={{
            '& div': {
              animation: 'width 100ms linear',
            },
          }}
        />
      ))}
    </styled.div>
  )
}
